import React from 'react'

export default function ProgressBar (props) {
  const { stats } = props

  return (
    <div className='progress progress-lg bg-secondary mb-3'>
      <div className='progress-bar' id='progress-bar-available' style={{ flex: toFlexValue(stats.available) }}>
        <div className='progress-bar bg-success' style={{ flex: toFlexValue(stats.available) }} {...addTooltip('available')} />
        <div className='progress-bar bg-future-success flatten-right-side' style={{ flex: '0.0' }} {...addTooltip('requested')} />
      </div>
      <div className='progress-bar bg-warning' id='progress-bar-pending' style={{ flex: toFlexValue(stats.pending) }} {...addTooltip('pending')} />
      <div className='progress-bar bg-info' style={{ flex: toFlexValue(stats.booked) }} {...addTooltip('planned')} />
      <div className='progress-bar bg-indigo' style={{ flex: toFlexValue(stats.used) }} />
    </div>
  )
}

function toFlexValue (floatNumber) {
  return parseInt(floatNumber) || 0
}

function addTooltip (name) {
  return { title: I18n.t(`calendar.stats.${name}`), rel: 'tooltip' }
}
